
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sucesso",
      function () {
        return require("private-next-pages/sucesso.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sucesso"])
      });
    }
  